import { BugReportBubble } from '@/components/global/BugReportBubble';
import { KnowledgeBaseBubble } from '@/components/global/KnowledgeBaseBubble';
import { AppContent } from '@/components/layout/AppContent';
import { AppHybridHeader } from '@/components/layout/AppHybridHeader';
import { AppShell } from '@/components/layout/AppShell';
import { AppSidebar } from '@/components/layout/AppSidebar';
import { ImpersonationBanner } from '@/components/layout/ImpersonationBanner';
import { SidebarInset } from '@/components/ui/shadcn/sidebar';
import { type BreadcrumbItem, type SharedData } from '@/types';
import { usePage } from '@inertiajs/react';
import { type PropsWithChildren } from 'react';

export default function AppSidebarLayout({ children, breadcrumbs = [] }: PropsWithChildren<{ breadcrumbs?: BreadcrumbItem[] }>) {
    const page = usePage<SharedData>();
    const { impersonation } = page.props;

    return (
        <AppShell variant="sidebar">
            <AppSidebar />
            <SidebarInset className="min-w-0">
                {impersonation?.is_impersonating && impersonation.impersonated_user && (
                    <ImpersonationBanner impersonatedUser={impersonation.impersonated_user} />
                )}
                <AppHybridHeader breadcrumbs={breadcrumbs} />
                <AppContent variant="sidebar">{children}</AppContent>
            </SidebarInset>
            <KnowledgeBaseBubble />
            <BugReportBubble />
        </AppShell>
    );
}
